import { useMutation, useQuery } from "@tanstack/react-query";
import client from "@/data/client";
import API_ENDPOINTS from "@/data/client/endpoints.ts";

interface DownloadFileInput {
  id: number | string;
  type?: string;
}

export function useDownloadFileQuery(
  input: DownloadFileInput,
  enabled?: boolean,
) {
  const { data, isLoading, error } = useQuery<Blob, Error>(
    [API_ENDPOINTS.GET_FILE(input.id), input.type],
    () => client.file.download(input),
    { enabled },
  );

  return {
    error,
    isLoading,
    blob: data,
  };
}

export function useDownloadFile() {
  return useMutation((input: DownloadFileInput) => client.file.download(input));
}
